import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { store } from "store";

const UrlHelper = {
  /**
   * @deprecated This function is deprecated. Use useSelector for Redux state access.
   *
   * Migration guide:
   * 1. Create a custom hook (e.g., useUrlHelper)
   * 2. Use useSelector to access Redux state instead of store.getState()
   * 3. Move this logic into the custom hook
   * 4. Use the hook in components instead of calling this function
   *
   * @see useSelector - React Redux hook for accessing state
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * const path = UrlHelper.formatPath("/some-path");
   *
   * @example
   * // New way (recommended):
   * function useUrlHelper() {
   *   const companyUrl = useSelector((state: AppState) => state.auth.selectedCompany.url);
   *
   *   const formatPath = (path: string): string => {
   *     return `/${companyUrl}${path}`;
   *   };
   *
   *   return { formatPath };
   * }
   *
   * // In component:
   * const { formatPath } = useUrlHelper();
   * const path = formatPath("/some-path");
   */
  formatPath: (path: string): string => {
    return `/${store.getState().auth.selectedCompany.url}${path}`;
  },

  getSearchParamsForQuery: (
    searchString: string,
    filterQueryStateHandler: FilterQueryStateHandler<any>
  ): URLSearchParams => {
    const searchParams = new URLSearchParams(searchString);
    const searchParamsEntries = searchParams.entries();

    const filterQueryStateHandlerEntries = Object.entries(filterQueryStateHandler);

    for (const [key] of searchParamsEntries) {
      const index = filterQueryStateHandlerEntries.findIndex(([queryHandlerKey]) => queryHandlerKey === key);

      if (index < 0) searchParams.delete(key);
    }

    return searchParams;
  },
};

export default UrlHelper;
